import { render } from "./index.vue?vue&type=template&id=74dacb50&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=74dacb50&lang=scss&scoped=true"

import exportComponent from "/builds/gh_devops/risk_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dacb50"]])

export default __exports__